export const EVENT_OPEN_CART_MODAL = 'open-cart-modal';
export const EVENT_CLOSE_CART_MODAL = 'close-cart-modal';
export const EVENT_MUTATE_CART_MODAL = 'mutate-cart-modal';

export const utilEventCartModal = {
  open: () => {
    window.dispatchEvent(new CustomEvent(EVENT_OPEN_CART_MODAL));
  },
  close: () => {
    window.dispatchEvent(new CustomEvent(EVENT_CLOSE_CART_MODAL));
  },
  mutate: () => {
    window.dispatchEvent(new CustomEvent(EVENT_MUTATE_CART_MODAL));
  },
  onOpen: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_OPEN_CART_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_OPEN_CART_MODAL, handler);
    };
  },

  onClose: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_CLOSE_CART_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_CLOSE_CART_MODAL, handler);
    };
  },

  onMutate: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_MUTATE_CART_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_MUTATE_CART_MODAL, handler);
    };
  }
};
